// date_created comes from the API as "YYYY-MM-DD"; parse as UTC so the
// displayed month doesn't shift a day/month off depending on local timezone.
export function formatMonthYear(dateString) {
  if (!dateString) return '';
  const date = new Date(`${dateString}T00:00:00Z`);
  return date.toLocaleDateString('en-US', {
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC',
  });
}
